/* Manor Hats theme v5: bag (Shopify Cart AJAX), drawers, upsells, filters, search, PDP helpers, popup.
   Port of the v5 demo app.js. Same data attributes; data-add carries a variant id, money is in cents. */
(function () {
  var T = window.theme || {}, R = T.routes || {}, S = T.strings || {};
  var ACC = T.accessoryTypes || [];
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function attr(v) { return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function toast(m) { var t = $('#Toast'); if (!t) return; t.textContent = m; t.classList.add('is-on'); clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2400); }
  function tr(key, vars) { var s = S[key] || ''; Object.keys(vars || {}).forEach(function (k) { s = s.split('{{ ' + k + ' }}').join(vars[k]); }); return s; }
  function money(cents) {
    var fmt = T.moneyFormat || '${{amount}}', v = (cents || 0) / 100;
    function num(dec, ts, ds) { var p = v.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds); }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', out;
    if (key === 'amount_no_decimals') out = num(0, ',', '.');
    else if (key === 'amount_with_comma_separator') out = num(2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') out = num(0, '.', ',');
    else if (key === 'amount_with_apostrophe_separator') out = num(2, "'", '.');
    else out = num(2, ',', '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]+>/g, '').replace(/[.,]00(?!\d)/, '').trim();
  }
  function img(u, w) { if (!u) return ''; u = String(u); if (/[?&]width=/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w); return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function isHat(it) { return ACC.indexOf(it.product_type) < 0; }
  function readJson(sel, fallback) { try { var el = $(sel); return el ? JSON.parse(el.textContent) : fallback; } catch (e) { return fallback; } }
  function isMobile() { return window.matchMedia && window.matchMedia('(max-width: 960px)').matches; }

  /* pre-order flags are not in /cart.js, so remember them per variant when added */
  var pre = {}; try { pre = JSON.parse(localStorage.getItem('manorPre') || '{}'); } catch (e) {}
  function markPre(id, on) { if (on) pre[id] = 1; else delete pre[id]; try { localStorage.setItem('manorPre', JSON.stringify(pre)); } catch (e) {} }

  /* ---------- stars (half-star rule from the demo) ---------- */
  var STAR_PATH = 'M12 2l3 6.6 7 .8-5.2 4.9 1.4 7L12 17.8 5.8 21.3l1.4-7L2 9.4l7-.8z';
  function starsHtml(n) {
    n = parseFloat(n) || 0;
    var full = Math.floor(n), frac = n - full, half = (frac >= 0.3 && frac < 0.8) ? 1 : 0; if (frac >= 0.8) full++;
    if (full > 5) full = 5;
    var s = '<svg viewBox="0 0 24 24"><path d="' + STAR_PATH + '"/></svg>', h = '<svg viewBox="0 0 24 24"><defs><linearGradient id="hg2"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="#ddd"/></linearGradient></defs><path fill="url(#hg2)" d="' + STAR_PATH + '"/></svg>', e = '<svg viewBox="0 0 24 24"><path fill="#ddd" d="' + STAR_PATH + '"/></svg>';
    return '<span class="stars" aria-label="' + attr(tr('starsLabel', { rating: n })) + '">' + s.repeat(full) + h.repeat(half) + e.repeat(Math.max(0, 5 - full - half)) + '</span>';
  }

  /* ---------- bag ---------- */
  function priceHtml(cents, cap) { return money(cents) + (cap && cap > cents ? ' <s>' + money(cap) + '</s>' : ''); }
  var cart = T.cart || { items: [], item_count: 0, total_price: 0, attributes: {} };
  var busy = false;
  function api(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function fail(err) { busy = false; toast((err && (err.description || err.message)) || S.failed); }
  function refresh() { return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; busy = false; render(); return c; }); }
  function add(items) {
    if (busy || !items.length) return Promise.reject();
    busy = true;
    return api(R.cartAdd + '.js', { items: items }).then(refresh).catch(function (e) { fail(e); throw e; });
  }
  function addForm(fd) {
    if (busy) return Promise.reject();
    busy = true;
    return fetch(R.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(refresh).catch(function (e) { fail(e); throw e; });
  }
  function change(key, q) {
    if (busy) return;
    busy = true;
    api(R.cartChange + '.js', { id: key, quantity: q }).then(function (c) { cart = c; busy = false; render(); }).catch(fail);
  }
  var giftTimer;
  function setGift(text) {
    clearTimeout(giftTimer);
    api(R.cartUpdate + '.js', { attributes: { 'Gift note': text || '' } }).then(function (c) { cart.attributes = c.attributes; }).catch(fail);
  }

  function render() {
    var c = cart, n = c.item_count || 0, sub = c.total_price || 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(sub); });
    var byTitle = {}, order = [];
    c.items.forEach(function (x) { (x.discounts || []).forEach(function (d) { var t = d.title || ''; if (!(t in byTitle)) { byTitle[t] = 0; order.push(t); } byTitle[t] += d.amount || 0; }); });
    if (!order.length) (c.cart_level_discount_applications || []).forEach(function (d) { var app = d.discount_application || d, t = app.title || ''; if (!(t in byTitle)) { byTitle[t] = 0; order.push(t); } byTitle[t] += (d.amount != null ? d.amount : app.total_allocated_amount) || 0; });
    var disc = order.filter(function (t) { return byTitle[t] > 0; }).map(function (t) { return { t: t, a: byTitle[t] }; });
    $$('[data-cart-discounts]').forEach(function (el) { el.innerHTML = disc.map(function (d) { return '<div class="drawer__disc"><span>' + attr(d.t) + '</span><span>&minus;' + money(d.a) + '</span></div>'; }).join(''); });
    var items = $('[data-cart-items]');
    if (items) {
      if (!c.items.length) items.innerHTML = '<p class="cempty">' + attr(S.empty) + '</p>';
      else items.innerHTML = c.items.map(itemHtml).join('') + addonHtml(c);
    }
    $$('[data-checkout]').forEach(function (b) { b.disabled = !c.items.length; });
    upsells(c);
    cartPage(c);
  }
  function variantLine(x) { return x.variant_title && x.variant_title !== 'Default Title' ? '<div class="v">' + attr(x.variant_title) + '</div>' : ''; }
  function qtyHtml(x, small) {
    return '<div class="qty"' + (small ? ' style="display:inline-flex;height:36px"' : '') + '><button type="button" data-cq="-1" data-key="' + attr(x.key) + '" aria-label="' + attr(S.decrease) + '">&minus;</button><input type="text" value="' + x.quantity + '" readonly' + (small ? ' style="width:36px"' : '') + ' aria-label="' + attr(S.quantity) + '"><button type="button" data-cq="1" data-key="' + attr(x.key) + '" aria-label="' + attr(S.increase) + '">+</button></div>';
  }
  function itemHtml(x) {
    return '<div class="citem"><a href="' + attr(x.url) + '">' + (x.image ? '<img src="' + attr(img(x.image, 200)) + '" alt="" width="70" height="86">' : '') + '</a>' +
      '<div><div class="t">' + attr(x.product_title) + '</div>' + variantLine(x) + (pre[x.variant_id] ? '<div class="v">' + attr(S.preorder) + '</div>' : '') +
      '<div class="ctl">' + qtyHtml(x) + '<button type="button" class="rm" data-rm="' + attr(x.key) + '">' + attr(S.remove) + '</button></div></div>' +
      '<div class="p">' + money(x.final_line_price) + '</div></div>';
  }
  function addonHtml(c) {
    var box = (readJson('[data-cart-config]', {}) || {}).hatBox;
    if (!box || !box.av) return '';
    var hasHat = c.items.some(isHat), inBag = c.items.some(function (x) { return x.handle === box.h; });
    if (!hasHat || inBag) return '';
    return '<div class="addon"><img src="' + attr(img(box.img, 100)) + '" alt="" width="46" height="56"><div class="t">' + attr(S.addonTitle) + '<small>' + attr(S.addonText) + ' ' + money(box.p) + (box.pre ? '. ' + attr(S.addonPre) : '') + '</small></div>' +
      '<button type="button" class="btn btn--sm btn--ghost" data-add="' + box.id + '"' + (box.pre ? ' data-pre="1"' : '') + '>' + attr(S.add) + '</button></div>';
  }
  function upsells(c) {
    var track = $('[data-upsell-track]'), wrap = $('[data-cart-upsells]');
    if (!track || !wrap) return;
    var inBag = c.items.map(function (x) { return x.handle; });
    var titles = c.items.map(function (x) { return (x.product_title || '').toLowerCase(); }).join(' ');
    var hasHat = c.items.some(isHat);
    var pool = (readJson('[data-cart-upsell-candidates]', []) || []).filter(function (p) { return p.av && inBag.indexOf(p.h) < 0 && (hasHat ? !p.hat : p.hat); });
    function match(p) { return p.col && titles.indexOf(String(p.col).toLowerCase()) >= 0 ? 1 : 0; }
    function prio(p) { var t = (p.t || '').toLowerCase(); return /glove/.test(t) ? 0 : /hairpiece|lapel|hair net|feather/.test(t) ? 1 : /foam/.test(t) ? 2 : /carrier|box/.test(t) ? 3 : 5; }
    pool.sort(function (a, b) { return match(b) - match(a) || prio(a) - prio(b) || a.p - b.p; });
    var picks = pool.slice(0, 6);
    wrap.hidden = !c.items.length || !picks.length;
    track.innerHTML = picks.map(function (p) {
      return '<div class="cross__item"><a href="' + attr(p.url) + '"><img src="' + attr(img(p.img, 260)) + '" alt="" loading="lazy" width="104" height="120"></a><div class="t">' + attr(p.t) + '</div><div class="p">' + priceHtml(p.p, p.cap) + '</div>' +
        '<button type="button" class="btn btn--sm btn--outline" data-add="' + p.id + '"' + (p.pre ? ' data-pre="1"' : '') + '>' + attr(S.add) + '</button></div>';
    }).join('');
  }
  function cartPage(c) {
    var body = $('[data-cart-page]'); if (!body) return;
    if (!c.items.length) { body.innerHTML = '<p class="cempty">' + attr(S.empty) + ' <a href="' + attr(R.allProducts) + '">' + attr(S.emptyLink) + '</a>.</p>'; return; }
    body.innerHTML = '<table><tbody>' + c.items.map(function (x) {
      return '<tr><td style="width:90px"><a href="' + attr(x.url) + '">' + (x.image ? '<img src="' + attr(img(x.image, 160)) + '" alt="" width="66" height="82">' : '') + '</a></td><td><div>' + attr(x.product_title) + '</div>' + (x.variant_title && x.variant_title !== 'Default Title' ? '<div class="v" style="color:var(--grey);font-size:.8rem">' + attr(x.variant_title) + '</div>' : '') + '</td>' +
        '<td>' + qtyHtml(x, true) + '</td>' +
        '<td style="text-align:right">' + money(x.final_line_price) + '<br><button type="button" class="rm" data-rm="' + attr(x.key) + '" style="font-size:.7rem;letter-spacing:.1em;text-transform:uppercase;color:var(--grey);border-bottom:1px solid currentColor">' + attr(S.remove) + '</button></td></tr>';
    }).join('') + '</tbody></table>';
  }

  /* ---------- drawers / modals ---------- */
  function open(id) { closeAll(); var el = $(id); if (el) { el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function closeAll() { $$('.drawer.is-open,.mmenu.is-open,.modal.is-open,.filters.is-open').forEach(function (d) { d.classList.remove('is-open'); if (d.classList.contains('filters')) d.removeAttribute('aria-hidden'); else d.setAttribute('aria-hidden', 'true'); }); document.body.style.overflow = ''; }
  function variantFor(scope) { var sel = scope && $('[data-variant-for]', scope); return sel ? sel.value : ''; }
  function itemFrom(el) {
    var id = variantFor(el.closest('.fitem, .cross__item, .addon')) || el.getAttribute('data-add');
    if (el.getAttribute('data-pre')) markPre(id, true);
    return { id: parseInt(id, 10), quantity: 1 };
  }
  function afterAdd(msg) { return function () { toast(msg); open('#CartDrawer'); }; }
  function swallow() {}

  document.addEventListener('click', function (e) {
    var t = e.target, b;
    if ((b = t.closest('[data-open-cart]'))) { e.preventDefault(); open('#CartDrawer'); return; }
    if ((b = t.closest('[data-open-menu]'))) { e.preventDefault(); open('#MobileMenu'); return; }
    if ((b = t.closest('[data-open-size]'))) { e.preventDefault(); open('#SizeModal'); return; }
    if ((b = t.closest('[data-open-filters]'))) { e.preventDefault(); open('#Filters'); return; }
    if ((b = t.closest('[data-close-all]'))) { e.preventDefault(); closeAll(); return; }
    if ((b = t.closest('[data-toggle-search]'))) { e.preventDefault(); var s = $('#SearchBar'); if (!s) return; s.classList.toggle('is-open'); if (s.classList.contains('is-open')) { var mi = $('#SearchInputMobile'); if (mi) mi.focus(); } return; }
    if ((b = t.closest('[data-add]')) && !t.closest('label.fitem')) {
      e.preventDefault();
      var it = itemFrom(b);
      if (b.getAttribute('data-qty-src')) { var q = $('#Qty'); it.quantity = Math.max(1, parseInt(q && q.value, 10) || 1); }
      add([it]).then(afterAdd(S.added), swallow); return;
    }
    if ((b = t.closest('[data-add-set]'))) {
      e.preventDefault();
      var set = []; try { set = JSON.parse(b.getAttribute('data-add-set')); } catch (x) {}
      var items = set.map(function (s) { if (s.pre) markPre(s.id, true); return { id: s.id, quantity: 1 }; });
      add(items).then(afterAdd(S.setAdded), swallow); return;
    }
    if ((b = t.closest('[data-cq]'))) { var key = b.getAttribute('data-key'), line = cart.items.find(function (x) { return x.key === key; }); if (line) change(key, line.quantity + parseInt(b.getAttribute('data-cq'), 10)); return; }
    if ((b = t.closest('[data-rm]'))) { change(b.getAttribute('data-rm'), 0); return; }
    if ((b = t.closest('[data-pdp-qty]'))) { var qi = $('#Qty'); if (!qi) return; var qv = Math.max(1, (parseInt(qi.value, 10) || 1) + parseInt(b.getAttribute('data-pdp-qty'), 10)); qi.value = qv; $$('[data-qty-mirror]').forEach(function (m) { m.value = qv; }); return; }
    if ((b = t.closest('[data-fin-add]'))) {
      e.preventDefault();
      var picked = $$('[data-fin]:checked');
      add(picked.map(itemFrom)).then(function () {
        picked.forEach(function (cb) { cb.checked = false; });
        finSum();
        toast(tr(picked.length === 1 ? 'pieceAdded' : 'piecesAdded', { count: picked.length }));
        open('#CartDrawer');
      }, swallow);
      return;
    }
    if ((b = t.closest('[data-thumb]'))) {
      var main = $('[data-gal-main]'); if (!main) return;
      main.src = b.getAttribute('data-thumb'); main.removeAttribute('srcset');
      $$('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      return;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.matches('[data-fin]') || el.matches('.fitem [data-variant-for]')) finSum();
    if (el.matches('[data-f]') || el.matches('[data-sort]')) applyFilters(el);
    if (el.matches('[data-gift]')) {
      var box = $('[data-gift-note]');
      if (box) box.hidden = !el.checked;
      if (el.checked) { if (box) { box.focus(); if (box.value) setGift(box.value); } }
      else { if (box) box.value = ''; setGift(''); }
    }
    if (el.matches('[data-option-select]')) variantChange();
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-qty-mirror]')) { var qi = $('#Qty'); if (qi) qi.value = Math.max(1, parseInt(e.target.value, 10) || 1); }
    if (e.target.matches('#Qty')) { $$('[data-qty-mirror]').forEach(function (m) { m.value = e.target.value; }); }
    if (e.target.matches('[data-gift-note]')) { var v = e.target.value; clearTimeout(giftTimer); giftTimer = setTimeout(function () { setGift(v); }, 600); }
  });
  function finSum() {
    var picked = $$('[data-fin]:checked'), sum = $('[data-fin-sum]'), btn = $('[data-fin-add]');
    if (!sum || !btn) return;
    var tot = picked.reduce(function (s, cb) {
      var sel = $('[data-variant-for]', cb.closest('.fitem')), opt = sel && sel.options[sel.selectedIndex];
      var p = opt && opt.getAttribute('data-price') ? parseInt(opt.getAttribute('data-price'), 10) : parseInt(cb.getAttribute('data-price'), 10);
      return s + (p || 0);
    }, 0);
    sum.innerHTML = picked.length ? tr('selected', { count: picked.length, amount: '<b>' + money(tot) + '</b>' }) : attr(S.nothingSelected);
    btn.disabled = !picked.length;
    btn.textContent = picked.length ? tr('addN', { count: picked.length }) : S.addSelected;
  }

  /* product form: Add to bag through /cart/add.js, fall back to a normal post if fetch fails */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-product-form]') && window.fetch && window.FormData) {
      e.preventDefault();
      var btn = $('[data-atc]', f);
      if (btn && btn.getAttribute('data-pre')) markPre($('[data-variant-id]', f).value, true);
      addForm(new FormData(f)).then(afterAdd(S.added), swallow);
    }
    if (f.matches('[data-checkout-form]')) { clearTimeout(giftTimer); }
    if (f.closest && f.closest('#Popup')) { setTimeout(closeAll, 300); }
  });

  /* ---------- variant picker (PDP) ---------- */
  var variants = readJson('[data-variants]', null);
  function variantChange() {
    if (!variants) return;
    var sel = $$('[data-option-select]').map(function (s) { return s.value; });
    var v = variants.find(function (x) { return sel.every(function (val, i) { return x.options[i] === val; }); });
    var idIn = $('[data-variant-id]'), btns = $$('[data-atc]');
    if (!v) { btns.forEach(function (b) { b.disabled = true; b.textContent = S.unavailable; }); return; }
    if (idIn) idIn.value = v.id;
    $$('[data-price]').forEach(function (p) { p.innerHTML = priceHtml(v.price, v.compare_at_price); });
    btns.forEach(function (b) { b.disabled = !v.available; b.textContent = !v.available ? S.soldOut : S.addToBag; });
    if (window.history && history.replaceState && window.URL) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
  }

  /* ---------- search (predictive, optional) ---------- */
  var searchTimer, activeSearch = null;
  function runSearch() {
    var inp = activeSearch || $('#SearchInput'), out = $('#SearchResults');
    if (!inp || !out) return;
    var q = (inp.value || '').trim(), base = out.getAttribute('data-predictive-url');
    var bar = $('#SearchBar');
    if (q.length < 2 || !base || !window.fetch) { out.className = 'sresults'; out.innerHTML = ''; return; }
    if (bar && !bar.classList.contains('is-open')) { bar.classList.add('is-open'); var mi = $('#SearchInputMobile'); if (mi && mi !== inp) mi.value = q; }
    fetch(base + encodeURIComponent(q), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) { var box = document.createElement('div'); box.innerHTML = html; var inner = box.querySelector('.shopify-section') || box; out.innerHTML = inner.innerHTML.trim(); out.className = out.innerHTML ? 'sresults has' : 'sresults'; })
      .catch(function () { out.className = 'sresults'; out.innerHTML = ''; });
  }
  $$('[data-search-input]').forEach(function (si) { si.addEventListener('input', function () { activeSearch = si; clearTimeout(searchTimer); searchTimer = setTimeout(runSearch, 250); }); });

  /* ---------- collection filters: GET form; auto-submit on desktop, Show results on phone ---------- */
  function applyFilters(el) {
    var form = (el && el.form) || $('[data-filters-form]');
    if (!form) return;
    if (el && el.matches('[data-sort]')) { var hidden = $('input[name="sort_by"]', form); if (hidden) hidden.value = el.value; form.submit(); return; }
    if (isMobile()) return;
    clearTimeout(form._t);
    form._t = setTimeout(function () { form.submit(); }, el && el.type === 'number' ? 600 : 0);
  }

  /* ---------- PDP: sticky bar + recently viewed ---------- */
  var buy = $('[data-buy-box]'), sticky = $('[data-sticky]');
  if (buy && sticky && 'IntersectionObserver' in window) {
    var atcBtn = $('.buyrow .btn', buy) || buy;
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-on', !en[0].isIntersecting); }, { threshold: 0 }).observe(atcBtn);
  }
  function cardHtml(p) {
    var flag = !p.av ? '<span class="flags"><span class="flag flag--out">' + attr(S.soldOut) + '</span></span>'
      : (p.new || p.pre) ? '<span class="flags">' + (p.new ? '<span class="flag flag--new">' + attr(S.newIn) + '</span>' : '') + (p.pre ? '<span class="flag">' + attr(S.preorder) + '</span>' : '') + '</span>' : '';
    var quick = !p.av ? '' : p.opt ? '<div class="card__quick"><a class="qbtn" href="' + attr(p.url) + '">' + attr(tr('choose', { option: String(p.opt).toLowerCase() })) + '</a></div>'
      : '<div class="card__quick"><button type="button" class="qbtn" data-add="' + p.id + '"' + (p.pre ? ' data-pre="1"' : '') + '>' + attr(p.pre ? S.preorder : S.quickAdd) + '</button></div>';
    var rev = p.rv ? '<div class="card__rev">' + starsHtml(p.rv[0]) + '<span class="rcount">(' + p.rv[1] + ')</span></div>' : '';
    var sub = p.col ? String(p.col).charAt(0).toUpperCase() + String(p.col).slice(1) + (p.mat ? ', ' + p.mat : '') : (p.mat ? String(p.mat).charAt(0).toUpperCase() + String(p.mat).slice(1) : (p.type || ''));
    return '<li class="card"><div class="card__media">' + (p.img ? '<img src="' + attr(img(p.img, 600)) + '" alt="' + attr(p.t) + '" loading="lazy" width="600" height="750">' : '') + (p.img2 ? '<img class="alt" src="' + attr(img(p.img2, 600)) + '" alt="" loading="lazy" width="600" height="750">' : '') + flag + quick + '</div>' +
      '<div class="card__info"><h3 class="card__title"><a href="' + attr(p.url) + '">' + attr(p.t) + '</a></h3>' + rev + '<div class="price">' + priceHtml(p.p, p.cap) + '</div><span class="card__sub">' + attr(sub) + '</span></div></li>';
  }
  var PDP = readJson('[data-pdp]', null);
  if (PDP) {
    var seen = []; try { seen = JSON.parse(localStorage.getItem('manorSeen') || '[]'); } catch (e) {}
    var others = seen.filter(function (p) { return p && p.h !== PDP.h; });
    var rwrap = $('[data-recent]'), rtrack = $('[data-recent-track]');
    if (rwrap && rtrack && others.length) { rwrap.hidden = false; rtrack.innerHTML = others.slice(0, 6).map(cardHtml).join(''); }
    seen = [PDP].concat(others).slice(0, 12);
    try { localStorage.setItem('manorSeen', JSON.stringify(seen)); } catch (e) {}
  }

  /* ---------- 15% off popup: once per session, after the delay, not on cart or product pages ---------- */
  (function () {
    var pop = $('#Popup'); if (!pop) return;
    var seenPop = false; try { seenPop = sessionStorage.getItem('manorPop') === '1'; } catch (e) {}
    if (seenPop || T.template === 'product' || T.template === 'cart') return;
    var delay = (parseInt(pop.getAttribute('data-popup-delay'), 10) || 6) * 1000;
    setTimeout(function () {
      if ($('.drawer.is-open,.mmenu.is-open,.modal.is-open')) return;
      pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false');
      try { sessionStorage.setItem('manorPop', '1'); } catch (e) {}
    }, delay);
  })();

  render();
  finSum();
})();
